import React from 'react';

import { Container, Tip } from './styles';
import Text from '../text';

interface IProps {
  texto: string;
  direcao?: 'direita' | 'esquerda';
  children: JSX.Element;
}

const ToolTip: React.FC<IProps> = ({ children, texto, direcao }) => {
  return (
    <Container aDireita={direcao === "direita"}>
      {children}
      <div>
        <Text className='!leading-5 !text-white !text-[.785rem]'>{texto}</Text>
      </div>
    </Container>
  )
}

export default ToolTip;